<script setup lang="ts">
import Header from './shared/components/header/Header.vue';
import Footer from '@/shared/components/footer/Footer.vue';
</script>

<template>
	<Header></Header>
	<router-view />
	<Footer></Footer>
</template>

<style lang="css">
html {
	body {
		margin: 0;
		height: 100%;
	}
}
</style>
